import { ErrorState } from "$components/error-state";
import { CloudOff } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

export const OfflineOnFirstLoadPage = () => (
  <ErrorState
    illustration={<CloudOff />}
    showRetry
    title={
      <FormattedMessage
        id="layout.initiallyOffline.title"
        defaultMessage="This page is not available"
      />
    }
    body={
      <FormattedMessage
        id="layout.initiallyOffline.body"
        defaultMessage="Please try again when you're back online."
      />
    }
  />
);
